module.exports = __webpack_public_path__ + "img/icon1.6f84d4f3.png";